import React, { useState } from "react";
import { BsFillPatchCheckFill } from "react-icons/bs";
import ScrollTrigger from "react-scroll-trigger";
import Skill from "../images/brazo2.png";

const Skills = () => {
  const [animationOn, setAnimationOn] = useState(false);

  return (
    <>
      <div className="skills" id="skills">
        <h1 className="mainHeading">Skills</h1>
        <p className="mainPara">My Technical Skills</p>
        {/* <div className="imgDiv">
          <img className="skillImg" src={Skill} alt="" />
        </div> */}
        <div className="skillsContent">
          <div className="skill animate__animated animate__fadeInLeft">
  <h3>Industrial Automation</h3>

  <div className="skillCon">

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> Allen-Bradley PLC
      </p>
      <p className="qual">Advanced</p>
    </div>

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> Studio 5000 / Logix 5000
      </p>
      <p className="qual">Advanced</p>
    </div>

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> Ladder Logic Programming
      </p>
      <p className="qual">Advanced</p>
    </div>

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> SCADA / HMI Development
      </p>
      <p className="qual">Intermediate</p>
    </div>

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> FactoryTalk View
      </p>
      <p className="qual">Intermediate</p>
    </div>

  </div>
</div>

<div className="skill animate__animated animate__fadeInLeft">
  <h3 className="segundo">Industrial Data</h3>

  <div className="skillCon">

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> Node-RED
      </p>
      <p className="qual">Intermediate</p>
    </div>

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> SQL Databases
      </p>
      <p className="qual">Intermediate</p>
    </div>

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> Industrial Data Logging
      </p>
      <p className="qual">Intermediate</p>
    </div>

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> Grafana Dashboards
      </p>
      <p className="qual">Intermediate</p>
    </div>

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> OPC UA
      </p>
      <p className="qual">Intermediate</p>
    </div>

  </div>
</div>

          <div className="skill animate__animated animate__fadeInLeft">
  <h3>Software Engineering</h3>

  <div className="skillCon">

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> Python
      </p>
      <p className="qual">Intermediate</p>
    </div>

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> C / C++
      </p>
      <p className="qual">Intermediate</p>
    </div>

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> REST APIs
      </p>
      <p className="qual">Intermediate</p>
    </div>

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> PostgreSQL
      </p>
      <p className="qual">Intermediate</p>
    </div>

    <div className="skillLang">
      <p className="lang">
        <BsFillPatchCheckFill className="langIcon" /> React
      </p>
      <p className="qual">Intermediate</p>
    </div>

  </div>
</div>
        </div>
      </div>
    </>
  );
};

export default Skills;
